import { Directive, TemplateRef, ViewContainerRef, Input, OnDestroy, HostListener } from '@angular/core';
import { PopulationQuery } from '@fgb/core';
import { Subscription } from 'rxjs';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[notInPopulation]',
})
export class NotInPopulationDirective implements OnDestroy {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private populationQuery: PopulationQuery
  ) {}
  private popSub: Subscription;

  @Input() set notInPopulation(populations: string[]) {
    this.popSub = this.populationQuery.selectCurrentPopulation().subscribe((p) => {
      this.viewContainer.clear();
      if (p && !populations.includes(p.DisplayName)) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    });
  }

  @HostListener('window:beforeunload')
  ngOnDestroy() {
    if (this.popSub) {
      this.popSub.unsubscribe();
    }
  }
}
